<template>
  <div class="spots">
    <div class="nav">
      <div class="logo"><img src="/assets/images/logo-navbar.svg"></div>
    </div>
        <div class="header-spots">
            <div v-if="langId === 'nl'" class="spots-title">KIES LOCATIE</div>
            <div v-if="langId === 'en'" class="spots-title">CHOOSE LOCATION</div>
            <div v-if="langId === 'de'" class="spots-title">LOKATION AUSWAEHLEN</div>
        </div>
      <div class="spots-container">
          <div class="spot-button" v-bind:key="spotItem.id" v-for="spotItem in spotItems" @click="openSpot(spotItem.id)">
              <img :src="spotItem.thumb" alt="thumb">
              <div class="spot-button-title">{{ decodeURI(spotItem.name) }}</div>
          </div>
      </div>
  </div>
</template>

<script>
import config from '@/config/config.json';
import axios from 'axios';
import router from '../router';

export default {
    name: "Spots",
    props: ['langId'],
    methods: {
        goLanguage() {
            router.push('/');
        },
        openSpot(spotIn) {
            router.push('/' + 'items/' + spotIn + '/' + this.langId);
        }
    },
    data() {
        return {
            configData: config,
            spotItems: []
        }
    },
    created() {
        const axiosSpots = this.configData.api + 'item_sets?@key_identity=' + config.key_identity + '&@key_credential=' + config.key_credential;
        axios.get(axiosSpots)
        .then((res) => {
            res.data.forEach((spotFound) => {
                let spotToPush = {
                    "id": spotFound["o:id"],
                    "thumb": spotFound.thumbnail_display_urls.medium,
                    "name": ""
                }
                spotFound["dcterms:title"].forEach((spotTitleFound) => {
                    if(spotTitleFound["@language"] === this.langId) {
                        // console.log('spotTitleFound: ' + JSON.stringify(spotTitleFound));
                        spotToPush.name = spotTitleFound["@value"];
                    }
                });
                // console.log('spotToPush: ' + JSON.stringify(spotToPush));
                this.spotItems.push(spotToPush);
            });
        })
        .catch();
    }
}
</script>

<style>
/* Mobile */
.header-spots {
    margin-top: 80px;
    width: 100%;
    color: white;
}
.spots-title {
    font-family: EtelkaMedium;
    font-size: 1.6em;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}

.spots {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #67808A;
}
.spots-container {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  height: 500px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.spot-button {
  position: relative;
  width: 100%;
  height: 25%;
  font-size: 1.4em;
  margin-bottom: 8px;
}
.spot-button-title {
  position: absolute;
  font-family: EtelkaMedium;
  color: white;
  bottom: 0;
  width: 96%;
  padding: 2%;
  background-color: #67808A99;
}

.spot-button img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
